var staticDecodeURIComponent = decodeURIComponent

module.exports = staticDecodeURIComponent



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticDecodeURIComponent.js
// module id = vgyl
// module chunks = 137